var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3591_14947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1667 2H7.83333C6.28681 2.00185 4.80415 2.61703 3.71059 3.71059C2.61703 4.80415 2.00185 6.28681 2 7.83333L2 24.1667C2.00185 25.7132 2.61703 27.1959 3.71059 28.2894C4.80415 29.383 6.28681 29.9981 7.83333 30H24.1667C25.7132 29.9981 27.1959 29.383 28.2894 28.2894C29.383 27.1959 29.9981 25.7132 30 24.1667V7.83333C29.9981 6.28681 29.383 4.80415 28.2894 3.71059C27.1959 2.61703 25.7132 2.00185 24.1667 2V2ZM7.83333 4.33333H24.1667C25.0949 4.33333 25.9852 4.70208 26.6415 5.35846C27.2979 6.01484 27.6667 6.90508 27.6667 7.83333V24.1667C27.6647 24.6864 27.545 25.1989 27.3167 25.6658L16.6265 14.9757C16.0848 14.4338 15.4417 14.004 14.7338 13.7108C14.026 13.4175 13.2673 13.2666 12.5012 13.2666C11.735 13.2666 10.9763 13.4175 10.2685 13.7108C9.56066 14.004 8.91753 14.4338 8.37583 14.9757L4.33333 19.017V7.83333C4.33333 6.90508 4.70208 6.01484 5.35846 5.35846C6.01484 4.70208 6.90508 4.33333 7.83333 4.33333ZM7.83333 27.6667C6.90508 27.6667 6.01484 27.2979 5.35846 26.6415C4.70208 25.9852 4.33333 25.0949 4.33333 24.1667V22.3163L10.0243 16.6253C10.3494 16.3001 10.7353 16.0421 11.1601 15.866C11.5849 15.69 12.0402 15.5994 12.5 15.5994C12.9598 15.5994 13.4151 15.69 13.8399 15.866C14.2647 16.0421 14.6506 16.3001 14.9757 16.6253L25.6658 27.3167C25.1989 27.545 24.6864 27.6647 24.1667 27.6667H7.83333Z",
    fill: "url(#paint0_linear_3591_14947)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6668 14.2497C21.4744 14.2497 22.2639 14.0102 22.9354 13.5615C23.6069 13.1128 24.1303 12.4751 24.4393 11.729C24.7484 10.9828 24.8293 10.1618 24.6717 9.36972C24.5141 8.57764 24.1252 7.85006 23.5542 7.27899C22.9831 6.70793 22.2555 6.31903 21.4634 6.16147C20.6714 6.00391 19.8503 6.08478 19.1042 6.39383C18.3581 6.70289 17.7203 7.22626 17.2717 7.89776C16.823 8.56927 16.5835 9.35874 16.5835 10.1663C16.5835 11.2493 17.0137 12.2879 17.7795 13.0537C18.5453 13.8195 19.5839 14.2497 20.6668 14.2497ZM20.6668 8.41634C21.0129 8.41634 21.3513 8.51898 21.6391 8.71127C21.9269 8.90356 22.1512 9.17688 22.2836 9.49665C22.4161 9.81642 22.4507 10.1683 22.3832 10.5078C22.3157 10.8472 22.149 11.159 21.9043 11.4038C21.6595 11.6485 21.3477 11.8152 21.0082 11.8827C20.6688 11.9502 20.3169 11.9156 19.9971 11.7831C19.6774 11.6507 19.404 11.4264 19.2118 11.1386C19.0195 10.8508 18.9168 10.5125 18.9168 10.1663C18.9168 9.70221 19.1012 9.25709 19.4294 8.92891C19.7576 8.60072 20.2027 8.41634 20.6668 8.41634Z",
    fill: "url(#paint1_linear_3591_14947)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3591_14947",
    x1: 2,
    y1: 33,
    x2: 33.2277,
    y2: 26.0847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3591_14947",
    x1: 16.5835,
    y1: 15.1247,
    x2: 25.6916,
    y2: 13.1077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3591_14947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarBackground);
export default __webpack_public_path__ + "static/media/avatar-background.f33ff05a35780b89b3822968972e2c84.svg";
export { ForwardRef as ReactComponent };